import React from "react";
import PropTypes from "prop-types";

import { getPermissibleActions } from "./utils.js";
import { useUserStore } from "../libs/stores/index.js";
import { ASTERISK } from "./constants.js";

/**
 * Expects module, resource, actions, strict and returns a boolean.
 * Used to check whether the user has required permissions
 * @param {string} module
 * @param {string} resource
 * @param {string[]} actions - List of actions eg:["read", "export"].
 * @param {boolean} [strict=false] - If strict is true, actions will work in AND condition,
 * If false, works in OR condition (default)
 * @returns {boolean}
 */
export function hasPermissions({ module, resource, actions, strict = false }) {
  let permissionObject = useUserStore.getState().permissions;
  const _allowedActions = getPermissibleActions(
    permissionObject,
    module,
    resource
  );

  const allowedActions = new Set(_allowedActions);

  if (allowedActions.has(ASTERISK)) {
    return true;
  }
  if (strict) {
    return actions.every((elem) => allowedActions.has(elem));
  } else {
    return actions.some((elem) => allowedActions.has(elem));
  }
}

export function RBAC(props) {
  const {
    children,
    module,
    resource,
    actions,
    strict = false,
    fallBack = null
  } = props;

  const canAccess = hasPermissions({
    module,
    resource,
    actions,
    strict
  });
  return canAccess ? <React.Fragment>{children}</React.Fragment> : fallBack;
}

RBAC.propTypes = {
  children: PropTypes.node.isRequired,
  module: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.string).isRequired,
  strict: PropTypes.bool,
  fallBack: PropTypes.element
};

export * from "./account.utils.js";
